import { IconNames } from './icon-names';

export enum IconSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum IconColor {
  Yellow = 'yellow',
  Black = 'black',
}

export enum IconType {
  AlertWarningFilled = IconNames.AlertWarningFilled,
  Message = IconNames.Message,
}
